"use client";

import type { QuoteUiStyle } from "@/@sdk/brands/brand-model";
import { cn } from "@/lib/utils";

const STYLE_OPTIONS: {
  value: QuoteUiStyle;
  label: string;
  description: string;
}[] = [
  {
    value: "STYLE_A",
    label: "Style A",
    description: "Classic cards with subtle borders and shadow",
  },
  {
    value: "STYLE_B",
    label: "Style B",
    description: "Soft surfaces with tinted sections",
  },
  {
    value: "STYLE_C",
    label: "Style C",
    description: "Editorial typography with accent bars",
  },
];

function StyleWireframe({ style }: { style: QuoteUiStyle }) {
  if (style === "STYLE_B") {
    return (
      <div className="space-y-2 p-2">
        <div className="h-8 rounded-xl bg-primary/10" />
        <div className="h-14 rounded-2xl bg-white/90" />
        <div className="h-10 rounded-2xl bg-primary/5" />
      </div>
    );
  }

  if (style === "STYLE_C") {
    return (
      <div className="space-y-2 p-2">
        <div className="h-6 border-l-4 border-primary pl-2 text-[10px] font-semibold">
          Heading
        </div>
        <div className="h-12 rounded-md border bg-white" />
        <div className="h-8 border-l-4 border-primary/40 pl-2" />
      </div>
    );
  }

  return (
    <div className="space-y-2 p-2">
      <div className="h-8 rounded-md bg-muted" />
      <div className="h-14 rounded-xl border bg-white shadow-sm" />
      <div className="h-10 rounded-xl border bg-white shadow-sm" />
    </div>
  );
}

export function UiStylePicker({
  value,
  onChange,
}: {
  value: QuoteUiStyle;
  onChange: (value: QuoteUiStyle) => void;
}) {
  return (
    <div className="grid gap-3 sm:grid-cols-3">
      {STYLE_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-lg border text-left transition-colors hover:bg-muted/50",
            value === option.value && "border-primary ring-1 ring-primary"
          )}
        >
          <StyleWireframe style={option.value} />
          <div className="border-t px-3 py-2">
            <p className="text-sm font-medium">{option.label}</p>
            <p className="text-xs text-muted-foreground">{option.description}</p>
          </div>
        </button>
      ))}
    </div>
  );
}
